import styled from 'styled-components';

const tableComponents = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const pagination = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
`;

const search = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const buttons = styled.div`
  display: flex;
  flex-direction: row;
`;

const searchAndButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const Wrapper = {
  TableComponents: tableComponents,
  Pagination: pagination,
  Search: search,
  Buttons: buttons,
  SearchAndButtons: searchAndButtons,
};

export default Wrapper;
